import { useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../config/firebase';

export interface LandingSettings {
  address: string;
  phone: string;
  whatsapp: string;
  email: string;
  facebookUrl: string;
  instagramUrl: string;
  twitterUrl: string;
  linkedinUrl: string;
  googlePlayUrl: string;
  appStoreUrl: string;
  windowsAppUrl: string;
  showFacebook: boolean;
  showInstagram: boolean;
  showTwitter: boolean;
  showLinkedin: boolean;
  heroTitle: string;
  heroSubtitle: string;
}

export const defaultSettings: LandingSettings = {
  address: "Antártida Argentina 1297, San Rafael, Mendoza, CP 5600",
  phone: "+54 260 4515854",
  whatsapp: "2604515854",
  email: "info@multigym.com.ar",
  facebookUrl: "#",
  instagramUrl: "#",
  twitterUrl: "#",
  linkedinUrl: "#",
  googlePlayUrl: "#",
  appStoreUrl: "#",
  windowsAppUrl: "/setup/Multigym_Control_Asistencia_Setup_v1.0.0.exe",
  showFacebook: true,
  showInstagram: true,
  showTwitter: true,
  showLinkedin: false,
  heroTitle: "Optimiza la gestión de tu gimnasio con MultiGym",
  heroSubtitle: "La solución completa para gestionar usuarios, rutinas de ejercicios y administrar suscripciones en tu gimnasio de forma digital."
};

export const useLandingSettings = () => {
  const [settings, setSettings] = useState<LandingSettings>(defaultSettings);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const docRef = doc(db, 'settings', 'landing');
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setSettings({
            ...defaultSettings,
            ...docSnap.data()
          });
        }
      } catch (error) {
        console.error('Error fetching landing settings from Firestore:', error);
      } finally {
        setSettings(prev => ({ ...prev })); // Disparar re-renderizado preventivo
        setLoading(false);
      }
    };

    fetchSettings();
  }, []);

  return { settings, loading };
};
